import * as angular from "angular";
import {AccountsAlerts} from "../../account/services/accounts-alerts.service";
import {IPromise, IQService, IWindowService} from "angular";
import {$accountFactory} from "../../account/$account.factory";
import {AccountModel} from "../../account/angular/models/account.model";

export class AccountsContextService {

  constructor(private $window: IWindowService, private $account: $accountFactory, private $q: IQService,
              private accountsAlerts: AccountsAlerts) {
  }

  getAccountIds(siteId: string): string[] {
    const accountsContextService = angular.fromJson(this.$window.localStorage.getItem('accountsContextService'));
    return accountsContextService && accountsContextService[siteId] ? accountsContextService[siteId] : [];
  }


  setAccountIds(siteId: string, accountIds: string[]) {

    let accountsContextService = angular.fromJson(this.$window.localStorage.getItem('accountsContextService'));

    if (!accountsContextService) {
      accountsContextService = {};
    }

    accountsContextService[siteId] = [];
    accountsContextService[siteId] = [].concat(accountIds);

    this.$window.localStorage.setItem('accountsContextService', angular.toJson(accountsContextService));
  }

  getFavouriteAccountId(siteId: string): string {
    const accountContext = angular.fromJson(this.$window.localStorage.getItem('favouriteAccountContext'));
    return accountContext && accountContext[siteId] ? accountContext[siteId] : undefined;
  }

  getFavouriteAccount(siteId: string): IPromise<AccountModel | void> {
    const accountContext = angular.fromJson(this.$window.localStorage.getItem('favouriteAccountContext'));
    return accountContext && accountContext[siteId] ? this.$account(accountContext[siteId]).$asyncValue() : this.$q.when();
  }

  setFavouriteAccountId(siteId: string, accountId: string) {
    let accountContext = angular.fromJson(this.$window.localStorage.getItem('favouriteAccountContext'));

    if (!accountContext) {
      accountContext = {};
    }

    accountContext[siteId] = accountId;
    this.$window.localStorage.setItem('favouriteAccountContext', angular.toJson(accountContext));
    this.accountsAlerts.saveFavouriteSuccess();
  }
}


angular
  .module('bringoz.admin.commons')
  .service('accountsContextService', AccountsContextService);
